import { Messages } from '../../../../codegen/Localize';
import { editFlow } from '../../../../flow/actions/EditFlowReduxAction';
import { selectEditingFlowsEnabled } from '../../../../flow/selectors/FlowSelectors';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IWebEditFlowAction } from '../../../../ts/ServerApi/types/actionNames';
import { getAppStore } from '../../../AppStore';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IWebEditFlowAction> = {
  name: EntityActionNames.EditFlow,
  translateName: Messages.editFlow,
  isVisible: (_, state: AppState) => state ? selectEditingFlowsEnabled(state) : selectEditingFlowsEnabled(getAppStore().getState()),
  isClickable: (availableActions: IWebEditFlowAction) => !!availableActions && availableActions.webEditFlow,
  createReduxAction: (targetItems: IContentInfo[]) => editFlow(targetItems[0])
};
